<template>
  <div>
    <div class="buttons">
      <a @click="clickBack" class="back">
        <vk-icon icon="triangle-left" ratio="2"></vk-icon>
      </a>
      <span v-if="isConfirmationScreen">リクエスト内容確認</span>
      <span v-else>リクエスト</span>
    </div>
    <div class="container">
      <p v-if="!isConfirmationScreen">デザインがわかる画像を添付またはURLを入力してください。</p>
      <ul class="errors" v-if="errors.length">
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
      <div v-if="image" class="preview"><img :src="image" /></div>
      <div v-if="url" class="preview"><img :src="url" /></div>
      <div class="contribution-buttons" v-if="!isConfirmationScreen">
        <input type="file" @change="imagePreview" accept="image/*" style="display:none;" ref="fileInput"/>
        <button v-if="image" class="btn btn-secondary" @click="$refs.fileInput.click()">画像を再選択</button>
        <button v-else       class="btn btn-secondary" @click="$refs.fileInput.click()">画像選択</button>
        <div>または画像URLを指定</div>
        <input type="text" class="form-control" placeholder="http://" v-model="url">
      </div>
      <div class="container" v-if="isConfirmationScreen">
        <div class="confirm__title">{{ title }}</div>
        <div class="confirm__email">{{ email }}</div>
      </div>

      <div v-if="!isConfirmationScreen">
        <div>
          <div class="row">
            <label>タイトル</label>
            <span>（必須）</span>
            <span>16文字以内</span>
          </div>
          <div v-if="!isConfirmationScreen">
            <input type="text" class="form-control" v-model="title" maxlength="16">
          </div>
        </div>
        <div>
          <div class="row">
            <label>メールアドレス</label>
          </div>
          <div>
            <input type="email" class="form-control" v-model="email" maxlength="200">
          </div>
        </div>
      </div>
      <div class="container" v-if="isConfirmationScreen">
        <p>上記内容でよろしければ「リクエスト送信」を押して、送信完了ページが表示されるまでお待ちください。<br>
          リクエスト画像や通信環境により読み込みに時間がかかる場合がございます。</p>
        <p>※ドメイン指定している場合は、@harigu.comを受信できるようにしてからご利用ください。</p>
      </div>
      <div class="contribution-buttons">
        <button class="btn btn-danger" @click="confirm" v-if="!isConfirmationScreen">リクエスト確認</button>
        <a href="#" class="btn btn-danger" @click="upload" :disabled="$store.state.loading" v-else>リクエスト送信</a>
      </div>
      <div v-if="!isConfirmationScreen" class="panel mt-2">
        <b>リクエスト利用規約</b><br>
        ・リクエスト受付後24時間以内にメールにてご連絡いたします。<br>
        ・リクエスト画像が小さい場合や、荒い場合、デザインが細かすぎる場合は受付できない場合がございます。<br>
        ・300ピクセル以上、10MB以内 、対応拡張子（JPG/PNG/GIF/BMP）、なるべく白黒2諧調<br>
      </div>
      <div v-if="isStandingMailer" class="panel mt-2">
        メール送信数分後にリクエスト受付メールをお送りします。メールをご確認ください
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'Contribution',
    components: {
    },
    data () {
      return {
        image: '',
        title: '',
        url: '',
        email: '',
        size: 0,
        errors: [],
        reader: new FileReader(),
        isConfirmationScreen: false,
        isStandingMailer: false,
      };
    },
    created () {
    },
    computed: {
    },
    methods: {
      imagePreview (event) {
        this.reader.onload = e => {
          this.size = e.total;
          this.image = e.target.result;
        };
        this.reader.readAsDataURL(event.target.files[0]);
      },
      confirm () {
        this.errors = [];
        // エラーチェック
        if (!this.image && !this.url) {
          this.errors.push('画像が選択されていません');
        }
        if (this.image && this.size > 1024 * 1024 * 1024 * 10) {
          this.errors.push('画像ファイルサイズが10Mを超えています');
        }
        if (this.url && !this.url.match(/(https?|ftp):\/\/.+/)) {
          this.errors.push('画像URLをご確認ください');
        }
        if (this.title === '') {
          this.errors.push('タイトルが入力されていません');
        }
        if (!this.validEmail(this.email)) {
          this.errors.push('メールアドレスが正しくありません');
        }
        this.title = this.title.slice(0, 16);
        if (this.errors.length === 0) {
          this.isConfirmationScreen = true;
        } else {
          scrollTo(0, 0);
        }
      },
      validEmail(email) {
        var re = /^[-+.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]{2,6}$/;
        return re.test(email);
      },
      async upload () {
        this.$store.commit('setLoading');
        try {
          const response = await axios
            .post('http://admin.harigu.com/api/contribution', {
              title: this.title,
              image: this.image,
              url: this.url,
              email: this.email,
            });
          if (response.statusText === 'OK') {
            this.$router.push({name: 'contributionSend'});
          } else {
            alert('エラーが発生しました');
          }
          // メーラー起動
          // this.isStandingMailer = true;
          // const address = 'upload@harigu.com';
          // const subject = `リクエストメール [ID:${response.data.token}]`;
          // const body = 'このまま送信してください。24時間を経過すると無効になりますのでもう一度リクエストしてください。';
          // location.href = 'mailto:' + address + '?subject=' + encodeURI(subject) + '&body=' + encodeURI(body);
        } catch (e) {
          alert('リクエストの送信に失敗しました');
        }
        this.$store.commit('resetLoading');
      },
      clickBack () {
        if (this.isConfirmationScreen) {
          this.isConfirmationScreen = false;
          this.isStandingMailer = false;
        } else {
          this.$router.push({path: '/'});
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .confirm__title {
    font-weight: bold;
    text-align: center;
  }
  .confirm__email {
    text-align: center;
  }
  .buttons {
    position: sticky;
    top: 48px;
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    z-index: 1;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
    &:after {
      clear: both;
    }
  }

  .container {
    padding: 1rem;
  }
  .row {
    margin: 0;
    margin-top: .6rem;
  }
  .rule {
    width: 100%;
    height: 10rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: .6rem;
    overflow-y: scroll;
    .title {
      text-align: center;
    }
  }
  .contribution-buttons {
    margin-top: 1rem;
    text-align: center;
    button {
      width: 60%;
      letter-spacing: .2rem;
    }
    input {
      width: 60%;
      margin: 0 auto;
    }
  }
  .errors {
    list-style: none;
    margin: 0;
    padding: 0;
    color: red;
  }
  .preview {
    text-align: center;
    img {
      max-width: 60%;
      max-height: 200px;
    }
  }
  .panel {
    font-size: 80%;
    background-color: #f0f3ff;
    border: 1px solid #e0e0e0;
    padding: 6px;
  }
</style>
